export function slugify(text) {
  if (text == null) return "";
  return String(text)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function buildFirearmSlug({ frn, make, model }) {
  return [frn, slugify(make), slugify(model)].filter(Boolean).join("-");
}

export function buildFirearmPath(result) {
  const frn = result?.frn?.raw ?? result?.frn;
  const make = result?.make?.raw ?? result?.make;
  const model = result?.model?.raw ?? result?.model;
  const slug = buildFirearmSlug({ frn, make, model });
  return `/firearm/${slug}`;
}

export function extractFrn(slug) {
  if (!slug) return null;
  const m = String(slug).match(/^(\d+)/);
  return m ? m[1] : null;
}

export function getFirearmLink(result) {
  return `${window.location.origin}${buildFirearmPath(result)}`;
}

export function openFirearmInNewTab(result) {
  const win = window.open();
  if (win) {
    win.opener = null;
    win.location = getFirearmLink(result);
  }
}

export async function copyFirearmLink(result) {
  await navigator.clipboard.writeText(getFirearmLink(result));
}
